import { useState, useEffect } from 'react';
import domain from '../../../reusecomponent/domain';
import { getToken } from '../../function/token';
import { SuccessToastContainer, ErrorToastContainer } from '../../function/CustomFunction';
import Preloader from '../preloader';

const containerStyles = {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  overflowX: 'hidden'
};

const cardStyles = {
  width: '100%',
  maxWidth: '100%',
  overflowX: 'hidden',
  boxSizing: 'border-box'
};

const cardBodyStyles = {
  padding: '1.5rem',
  overflowX: 'hidden',
  boxSizing: 'border-box'
};

const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1050,
  padding: '20px'
};

const modalContentStyle = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  width: '100%',
  maxWidth: '900px',
  maxHeight: '90vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};

const modalBodyStyle = {
  padding: '20px',
  overflowY: 'auto'
};

const preStyle = {
  background: '#f4f6f8',
  padding: '15px',
  borderRadius: '6px',
  fontSize: '13px',
  maxHeight: '500px',
  overflowY: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
};

const WebhookConfiguration = () => {

  const [formData, setFormData] = useState({ webhookUrl: '' });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [webhooks, setwebhooks] = useState([]);
  const [modal, setModal] = useState({ open: false, request: null, response: null });

  useEffect(() => {
    fetchWebhookConfiguration();
  }, []);

  const fetchWebhookConfiguration = async () => {

    setLoading(true);

    try {

      const response = await fetch(`${domain()}/webhook-get`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });

      const data = await response.json();

      if (response.ok && data.status) {
        setFormData({ webhookUrl: data.data?.webhookurl || '' });
        setwebhooks(data.data?.webhooklog || []);
      }

    } finally {
      setLoading(false);
    }

  };

  const handleInputChange = (e) => {

    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setSaving(true);

    try {

      const response = await fetch(`${domain()}/webhook-set`, {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        },

        body: JSON.stringify({ webhook: formData.webhookUrl })

      });

      const data = await response.json();

      if (response.ok) {

        SuccessToastContainer(data.message || 'Saved');
        fetchWebhookConfiguration();

      } else {

        ErrorToastContainer(data.message || 'Failed');

      }

    } finally {

      setSaving(false);

    }

  };

  const shortUrl = (url) => url.length > 20 ? url.substring(0, 20) + '...' : url;

  const formatJson = (data) => {

    try {

      if (typeof data === 'string') {
        return JSON.stringify(JSON.parse(data), null, 2);
      }

      return JSON.stringify(data, null, 2);

    } catch {
      return data;
    }

  };

  if (loading) {

    return (

      <div className="row" style={containerStyles}>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card" style={cardStyles}>
            <div className="card-body" style={cardBodyStyles}>
              <Preloader action={loading} />
            </div>
          </div>
        </div>
      </div>

    );

  }

  return (

    <div className="row" style={containerStyles}>

      <div className="col-lg-12 grid-margin stretch-card">

        <div className="card" style={cardStyles}>

          <div className="card-body" style={cardBodyStyles}>

            <h4 className="card-title">Webhook Configuration</h4>

            <form onSubmit={handleSubmit}>

              <div className="form-group">

                <label>Webhook URL</label>

                <input
                  type="url"
                  className="form-control"
                  name="webhookUrl"
                  value={formData.webhookUrl}
                  onChange={handleInputChange}
                />

              </div>

              <button className="btn btn-primary" disabled={saving}>
                {saving ? 'Saving...' : 'Save Configuration'}
              </button>

            </form>

            <div className="table-responsive mt-4">

              <table className="table table-bordered table-striped">

                <thead>

                  <tr>
                    <th>ID</th>
                    <th>URL</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>View</th>
                  </tr>

                </thead>

                <tbody>

                  {webhooks.length === 0 && (

                    <tr>
                      <td colSpan="5" className="text-center">No Records</td>
                    </tr>

                  )}

                  {webhooks.map((row) => (

                    <tr key={row.id}>

                      <td>{row.id}</td>

                      <td title={row.webhook_url}>
                        {shortUrl(row.webhook_url)}
                      </td>

                      <td>

                        <span className={`badge ${row.response_status_code === 200 ? 'badge-success' : 'badge-danger'}`}>
                          {row.response_status_code}
                        </span>

                      </td>

                      <td>
                        {new Date(row.created_at).toLocaleString()}
                      </td>

                      <td>

                        <button
                          className="btn btn-sm btn-info"
                          onClick={() =>
                            setModal({
                              open: true,
                              request: row.request_body,
                              response: row.response_body
                            })
                          }
                        >
                          View
                        </button>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

      {/* CENTER MODAL */}

      {modal.open && (

        <div style={modalOverlay}>

          <div style={modalContentStyle}>

            <div className="modal-header">

              <h5 className="modal-title px-4 pt-2">Webhook Details</h5>

              <button
                className="close mr-2"
                onClick={() => setModal({ open: false })}
              >
                ×
              </button>

            </div>

            <div style={modalBodyStyle}>

              <h6><strong>Request</strong></h6>

              <pre style={preStyle}>
                {formatJson(modal.request)}
              </pre>

              <h6 className="mt-3"><strong>Response</strong></h6>

              <pre style={preStyle}>
                {formatJson(modal.response)}
              </pre>

            </div>

          </div>

        </div>

      )}

    </div>

  );

};

export default WebhookConfiguration;